/**
 * Country breakout (USA / Canada) shared vocabulary.
 *
 * The pipeline classifies every regional row as one of these two countries or
 * 'Other'; the UI only ever asks for the two named ones. The values are the
 * literal `md_country` strings in ClickHouse AND the values stored in
 * `metadata.regional.ga_property_countries`, so they must not be renamed.
 */
export type RegionalCountry = "USA" | "Canada"

export const REGIONAL_COUNTRIES: RegionalCountry[] = ["USA", "Canada"]

export const REGIONAL_COUNTRY_LABELS: Record<RegionalCountry, string> = {
  USA: "US",
  Canada: "Canada",
}

export const REGIONAL_COUNTRY_OPTIONS: Array<{
  label: string
  value: RegionalCountry
}> = REGIONAL_COUNTRIES.map(country => ({
  value: country,
  label: REGIONAL_COUNTRY_LABELS[country],
}))

export function isRegionalCountry(value: unknown): value is RegionalCountry {
  return value === "USA" || value === "Canada"
}

/**
 * pipeline-dbt joins the GA4 property → country map on the BARE numeric
 * property id, so strip the `properties/` prefix the GA Admin API uses.
 */
export function normalizeGaPropertyId(propertyId: string): string {
  return propertyId.trim().replace(/^properties\//, "")
}
